export const STORAGE_KEYS = {
  BRAND_ID: 'thaihand-booking-brandId',
  STORE_ID: 'thaihand-booking-storeId',
  OTP_REF: 'thaihand-booking-otp-ref',
  AUTH_TOKEN: 'thaihand-booking-auth-token',
  BOOKING_DONE: 'thaihand-booking-done',
  BOOKING_STORE: 'booking-store',
  USER_STORE: 'thaihand-booking-user',
  I18N_LANGUAGE: 'i18nextLng',
  USER_SELECTED_LANGUAGE: 'user-selected-language',
} as const;
